import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateForm } from 'src/app/can-deactivate-form';
import { DayReportFormComponent } from './day-report-form/day-report-form.component';
import { DayReportHourControlComponent } from './day-report-hour-control/day-report-hour-control.component';
import { DayReportMaterialenComponent } from './day-report-materialen/day-report-materialen.component';
import { DayReportComponent } from './day-report.component';

const routes: Routes = [
    {
        path: '',
        component: DayReportComponent,
        title: 'Dagrapport',
        children: [
            {
                path: '',
                redirectTo: 'productie',
                pathMatch: 'full',
            },
            {
                path: 'productie',
                component: DayReportMaterialenComponent,
                title: 'Dagrapport productie',
            },
            {
                path: 'formulier',
                component: DayReportFormComponent,
                title: 'Dagrapport formulier',
                canDeactivate: [CanDeactivateForm],
            },
            {
                path: 'urenregistratie',
                component: DayReportHourControlComponent,
                title: 'Dagrapport urenregistratie',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DayReportRoutingModule {}
